import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Network } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LABELS = { sepolia: 'Sepolia (test)', mainnet: 'Ethereum', base: 'Base', arbitrum: 'Arbitrum' };

export const IssuanceNetworkCard = ({ token }) => {
  const [data, setData] = useState(null);
  const [choice, setChoice] = useState('');
  const headers = { Authorization: `Bearer ${token}` };

  const load = async () => {
    const r = await axios.get(`${API}/pas-admin/issuance-network`, { headers });
    setData(r.data); setChoice(r.data.network || '');
  };
  useEffect(() => { load().catch(() => toast.error('Could not load issuing network')); }, [token]);

  const save = async () => {
    try {
      await axios.put(`${API}/pas-admin/issuance-network`, { network: choice || null }, { headers });
      toast.success(choice ? `New checks and agreements now use ${LABELS[choice]}` : 'Using the default networks again');
      load();
    } catch (e) { toast.error(e.response?.data?.detail || 'Could not save'); }
  };

  if (!data) return null;
  return (
    <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-3" data-testid="issuance-network-card">
      <div className="flex items-center gap-3"><Network className="w-5 h-5 text-sky-400" /><h3 className="text-white font-semibold">Network for new checks &amp; agreements</h3></div>
      <p className="text-sm text-slate-400">New Treasury Checks, Crypto Check records and on-chain Credit Agreements use this network. A network can be picked once both the Credit Agreement and Treasury Check contracts are deployed there.</p>
      <div className="flex flex-wrap items-center gap-3">
        <select value={choice} onChange={(e) => setChoice(e.target.value)} data-testid="issuance-network-select"
          className="bg-slate-900 border border-slate-600 rounded px-3 py-2 text-white text-sm">
          <option value="">Default (as before)</option>
          {Object.keys(LABELS).map(n => (
            <option key={n} value={n} disabled={!data.eligible.includes(n)}>{LABELS[n]}{data.eligible.includes(n) ? '' : ' (deploy both contracts first)'}</option>
          ))}
        </select>
        <button onClick={save} disabled={choice === (data.network || '')} data-testid="issuance-network-save-btn"
          className="px-4 py-2 text-sm rounded bg-sky-500 hover:bg-sky-600 disabled:bg-slate-700 disabled:text-slate-500 disabled:cursor-not-allowed text-white">Save</button>
        <span className="text-xs text-slate-400" data-testid="issuance-network-current">Current: {data.network ? LABELS[data.network] : 'Default'}</span>
      </div>
    </div>
  );
};

export default IssuanceNetworkCard;
